import {
  TradeDirection,
  TradeFlow,
} from '../../graphQL/types/shared';
import {
  GraphExportType,
} from '../../Utils';
import {
  InflationAdjustment,
  IRibbon,
  Layout,
  PopulationAdjustment,
} from '../../workerStore/stack/Utils';

export interface IExportInput {
  width: number;
  height: number;
  ribbons: IRibbon[];
  exportType: GraphExportType;
  xAxisMax: number;
  xAxisMin: number;
  yAxisMax: number;
  yAxisMin: number;
  layout: Layout;
  inflationAdjustment: InflationAdjustment;
  populationAdjustment: PopulationAdjustment;
  tradeDirection: TradeDirection;
  tradeFlow: TradeFlow;
  title: string;
}

export const leftMargin = 100;
export const bottomMargin = 100;
export const topMargin = 50;
export const rightMargin = 50;

export const tickLength = 13;
export const tickThickness = 2;
export const tickColor = 'black';

export const axisThickness = 1;
export const axisColor = 'black';

export const tickLabelSeparationFromAxis = 20;

export const gridlineThickness = 2;
export const gridlineColor = '#ccc';
